module.exports = __webpack_public_path__ + "img/shiba-loading.5ca1169b.png";